import { GoalThemeSaveRequestDto } from '../dto/request/goal-theme-save-request.dto';
import { GoalThemeUpdateRequestDto } from '../dto/request/goal-theme-update-request.dto';
import { GoalThemeResponseDto } from '../dto/response/goal-theme-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class GoalThemeService extends BaseLandscapeService {
  public async fetchGoalThemes(): Promise<GoalThemeResponseDto[]> {
    const response = await this.get<GoalThemeResponseDto[]>(`/goaltheme`);
    return response.data;
  }

  public async fetchGoalThemeById(id: string): Promise<GoalThemeResponseDto> {
    const response = await this.get<GoalThemeResponseDto>(`/goaltheme/${id}`);
    return response.data;
  }

  public async fetchGoalThemesByGoalId(
    id: string
  ): Promise<GoalThemeResponseDto[]> {
    const response = await this.get<GoalThemeResponseDto[]>(
      `/goaltheme/getbygoalid/${id}`
    );
    return response.data;
  }

  public async createGoalTheme(
    saveRequest: GoalThemeSaveRequestDto
  ): Promise<GoalThemeResponseDto> {
    const response = await this.post<GoalThemeResponseDto>(
      `/goaltheme`,
      saveRequest
    );
    return response.data;
  }

  public async updateGoalTheme(
    updateRequest: GoalThemeUpdateRequestDto
  ): Promise<GoalThemeResponseDto> {
    const response = await this.put<GoalThemeResponseDto>(
      `/goaltheme`,
      updateRequest
    );
    return response.data;
  }

  public async deleteGoalTheme(existingId: string): Promise<void> {
    await this.delete<void>(`/goaltheme/${existingId}`);
  }
}

const goalThemeService = new GoalThemeService();
export default goalThemeService;
